import { Box, Typography, styled } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";

import { imagesList } from "../../constants";
import { primary } from "../../constants/theme";

const CustomTurnoAssured = styled(Box)(() => ({
  background: "#FFFAEA",
  padding: "25px 0px",
  ".swiper-slide": {
    display: "flex",
    justifyContent: "center",
    ".turno-in-india-card": {
      transform: "scale(0.9)",
    },
  },
  ".swiper-slide.swiper-slide-active": {
    ".turno-in-india-card": {
      transform: "scale(1)",
    },
  },
  ".swiper-button-prev": {
    color: "grey",
  },
  ".swiper-button-next": {
    color: "grey",
  },
}));

const TurnoAssured = ({ x, setX }) => {
  const targetRef = useRef(null);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        setX("relative");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRef]);
  const swiper = useSwiper();
  const [count, setCount] = useState(0);
  const whyTurnoSlides = [
    {
      imageName: "whyTurno1",
      title: "Vehicle Selection",
      body: "We make it easy for you to find, buy and own your perfect electric 3 Wheeler as a trusted business partner. You do the browsing, we do everything else!We also provide support and advice if you have any questions or concerns while owning your new electric 3 Wheeler. Let us help you find the right electric 3 Wheeler today.",
    },
    {
      imageName: "whyTurno2",
      title: "Financing",
      body: "Get access to the best deals and financing offers with our customized financing options, lowest interest rates, zero documentation and no hidden charges.",
    },
    {
      imageName: "whyTurno3",
      title: "Buyback Guarantee",
      body: "We're pretty sure you'll love your new EV, but if you are looking to sell or upgrade your vehicle in 3 years, Turno offers you a guaranteed exchange value of up to INR 1,50,000.",
    },
    {
      imageName: "whyTurno4",
      title: "Vehicle Management ",
      body: "Track and monitor your vehicles anytime,anywhere including location and battery information and a whole lot more- All our vehicles are fitted with the latest technology that helps you monitor your vehicles in real time - at no additional cost!",
    },
  ];
  return (
    <CustomTurnoAssured>
      <Box id="turno-assured" ref={targetRef}>
        <Box>
          <Typography
            style={{ margin: "20px", fontSize: "20px", fontWeight: "700" }}
          >
            Turno Assured
          </Typography>
        </Box>
        <Box>
          <Typography
            style={{ margin: "20px", fontSize: "24px", fontWeight: "700" }}
          >
            <span style={{ color: primary.main }}>Get upto</span> 40%*{" "}
            <span style={{ color: primary.main }}>Assured resale value </span>&
            more Turno Assured
          </Typography>
        </Box>

        {/* Swiper */}
        <Box>
          <Swiper
            slidesPerView={1.4}
            spaceBetween={0}
            centeredSlides={true}
            pagination={false}
            loop={true}
            modules={[Pagination]}
            className="swiper-turno-india"
            // navigation={true}
            onSlideChange={() => {
              let slideCount = count;
              setCount(slideCount + 1);
              if (slideCount + 1 >= 2) {
                // sendAnalytics("why_turno_slide_changed", {}, "en");
              }
            }}
          >
            {whyTurnoSlides.map((data, index) => {
              return (
                <SwiperSlide key={index}>
                  <Box
                    className="turno-in-india-card"
                    sx={{
                      background: "#ffffff",
                      padding: "10px",
                      // width: "230px",
                      height: "380px",
                    }}
                  >
                    <Box>
                      <LazyLoadImage
                        width={"100%"}
                        src={imagesList[data.imageName]}
                        alt={imagesList[data.imageName]}
                      />
                    </Box>
                    <Box style={{ marginTop: "20px" }}>
                      <Typography
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {data.title}
                      </Typography>
                    </Box>
                    <Box style={{ marginTop: "20px" }}>
                      <Typography
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {data.body}
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>
      </Box>
    </CustomTurnoAssured>
  );
};

export default TurnoAssured;
